import React from 'react';
import { Button, Dropdown, Header } from 'semantic-ui-react';

import { Fecha } from 'src/componentes';

export const ClaseActual = (props: {
    claseActual: number;
    claseMaxima: number;
    fecha: string;
    alCambiarAClase: (clase: number) => void;
    alPresionarAtras: () => void;
    alPresionarAdelante: () => void;
}) => {
    const {
        claseActual,
        claseMaxima,
        fecha,
        alCambiarAClase,
        alPresionarAtras,
        alPresionarAdelante,
    } = props;
    const clasesOptions = Array.from({ length: claseMaxima }).map((_, i) => ({
        key: i + 1,
        value: i + 1,
        text: i + 1,
    }));

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Button icon='angle left' disabled={claseActual === 1} onClick={alPresionarAtras} />

            <Header textAlign='center' style={{ padding: '0 1em' }}>
                Clase{' '}
                <Dropdown
                    options={clasesOptions}
                    value={claseActual}
                    onChange={(_, { value }) => alCambiarAClase(Number(value))}
                    inline
                    scrolling
                />
                <Header.Subheader>
                    <Fecha fecha={fecha} />
                </Header.Subheader>
            </Header>

            <Button
                icon='angle right'
                disabled={claseActual === claseMaxima}
                onClick={alPresionarAdelante}
            />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Asistencia/AsistenciaPrevia/ClaseActual.tsx